import { ReportDataBasicStaticRow as Row } from '@/typings/api/Report'
import { LK_ROADMAPS_FEED_ROUTES } from '@/views/LKRoadmapsFeed/utils'
import {
  RoadmapEventStatuses,
  getRoadmapEventStatusesColor,
  getRoadmapEventStatusesColorByRole,
} from '@/typings/api/RoadmapEvent'


const TYPE_MAP = {
  region: 'Регион',
  municipality: 'Муниципалитет',
  school: 'ОО',
}


// мягкий перенос - &shy;

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Объект АТЕ',
    value: 'name',
    sortable: false,
    field: (name: Row['name'], data: Row) => ({
      to: data.type && {
        name: LK_ROADMAPS_FEED_ROUTES.LIST,
        query: { [data.type]: data.id },
      },
      type: data.type,
      typeName: data.type && TYPE_MAP[data.type],
      name,
    }),
  },
  {
    text: 'Количество',
    value: 'direction_count',
    width: 60,
    align: 'center',
    sortable: false,
  },
  {
    text: 'Не&nbsp;подтверждено',
    value: 'direction_unconfirmed_count',
    width: 60,
    align: 'center',
    style: `color: ${getRoadmapEventStatusesColorByRole(RoadmapEventStatuses.expired, true, false)}`,
    sortable: false,
  },
  {
    text: 'Подтверждено',
    value: 'direction_confirmed_count',
    width: 60,
    align: 'center',
    style: `color: ${getRoadmapEventStatusesColorByRole(RoadmapEventStatuses.done, true, false)}`,
    sortable: false,
  },

  {
    text: 'Количество',
    value: 'event_count',
    width: 60,
    sortable: false,
  },
  {
    text: 'Выполнение',
    value: 'event_in_progress_count',
    width: 60,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.inProgress)}`,
    sortable: false,
  },
  {
    text: 'Не&nbsp;выполнено',
    value: 'event_expired_count',
    width: 60,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.expired)}`,
    sortable: false,
  },
  {
    text: 'Выполнено',
    value: 'event_done_count',
    width: 60,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.done)}`,
    sortable: false,
  },
  {
    text: 'Требуется доработка',
    value: 'event_need_works_count',
    width: 60,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.needsWork)}`,
    sortable: false,
  },
  {
    text: 'Подтверждено',
    value: 'event_confirmed_count',
    width: 60,
    style: `color: ${getRoadmapEventStatusesColor(RoadmapEventStatuses.confirmed)}`,
    sortable: false,
  },
])
